module.exports = __webpack_public_path__ + "static/media/apicafe-logo-notext.4820d909.svg";